export default __webpack_public_path__ + "static/media/project.655282d1.png";